import { BaseTemplateElement } from './base-template-element.model';
import { Base } from './report-editor.model';
import { LinkedVisuals } from './template-dto.model';

export class KpiSetElement extends BaseTemplateElement {
    linkedVisuals: LinkedVisuals[];
    useTitle?: boolean;

    constructor(base: Base, linkedVisuals: LinkedVisuals[], useTitle?: boolean) {
        super(base);
        this.linkedVisuals = linkedVisuals;
        this.useTitle = useTitle;
    }
}
